import { useEffect, useState } from "react";
/**
 * The visual viewport's height and offset, updated when the on-screen
 * keyboard opens or closes or the page is zoomed. A sheet that takes this
 * height keeps its composer above the keyboard (iOS does not shrink 100dvh
 * for the keyboard).
 */
export function useVisualViewport(enabled = true) {
    const [box, setBox] = useState(null);
    useEffect(() => {
        const vv = typeof window !== "undefined" ? window.visualViewport : null;
        if (!enabled || !vv) {
            setBox(null);
            return;
        }
        const update = () => setBox({ height: Math.round(vv.height), offsetTop: Math.round(vv.offsetTop) });
        update();
        vv.addEventListener("resize", update);
        vv.addEventListener("scroll", update);
        return () => {
            vv.removeEventListener("resize", update);
            vv.removeEventListener("scroll", update);
        };
    }, [enabled]);
    return box;
}
